/**
 * Content view for showing dialogs
 *
 * @constructor
 */
var PopupDialog = require("../common/PopupDialog");

function DialogContentView() {
    var currentView;

    var views = [];
    var viewCount = 0;

    /** @type {jQuery} */
    var $content = $("#mobileResources");

    /**
     * Sets the specified view to be the one currently displayed by the content view.
     *
     * @param {AbstractView} view - The view to be displayed
     */
    this.setView = function(view) {
        currentView = view;
    };

    /**
     * Adds the content of the specified view to the container element for this content view
     *
     * @param {AbstractView} view - The view to be added to the content view
     */
    this.addView = function(view) {
        $content.append(view.getContent());
        views[viewCount++] = view;
    };

    /**
     * Shows the content view
     */
    this.show = function() {
        if (currentView) {
            // Need to check if there is a popup already open since we can only have one at a time.
            // If there is, then we show the error once that popup has closed
            var currentDialog = $(".ui-popup-container:not(.ui-popup-hidden) .ui-popup");

            if (currentDialog.length === 0) {
                PopupDialog.showPopup(currentView.getContent(), currentView.getAnchor());
                currentView.show();
            } else {
                currentDialog.one("popupafterclose", function() {
                    PopupDialog.showPopup(currentView.getContent(), currentView.getAnchor());
                    currentView.show();
                });
            }
        }
    };

    /**
     * Hides the content view and its header
     */
    this.hide = function() {
        if (currentView) {
            currentView.getContent().popup("close");
            currentView.hide();
        }
    };

    this.resize = function(width, height) {
        views.forEach(function(view) {
            view.resize(width, height);
        });

        // TODO also need to consider repositioning of current dialog
    };
}

module.exports = DialogContentView;


//////////////////
// WEBPACK FOOTER
// ./common/DialogContentView.js
// module id = 15
// module chunks = 3 4